import { z } from "zod";
import { schemes } from "@zeal/common";

export const createInvoicePayoutRequestSchema = z.object({
  companyID: schemes.uuid(),
});

export const createInvoicePayoutResponseSchema = z.object({
  success: z.boolean(),
  payout_transaction_id: z.string().optional(),
  amount: z.number(),
  invoice_count: z.number(),
  transaction_id: z.string().optional(),
  message: z.string().optional(),
});

export const createInvoicePayoutResponseWrapperSchema = z.object({
  success: z.boolean(),
  testMode: z.boolean(),
  data: createInvoicePayoutResponseSchema,
});

export type TCreateInvoicePayoutRequest = z.infer<
  typeof createInvoicePayoutRequestSchema
>;
export type TCreateInvoicePayoutResponse = z.infer<
  typeof createInvoicePayoutResponseWrapperSchema
>;
